import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { Link } from 'react-router-dom';
import { Table, Button, Icon } from 'antd';
import helpers from '../../utils/helpers';
import styles from './styles.less';

class VisitsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { Column } = Table;
    const {
      dataSource,
      intl,
      columnBtn,
      bottomBtn,
      columnBtnAction,
      bottomBtnAction,
      title,
      includeParam,
      rowKey,
    } = this.props;

    return (<div className={styles.visitsWr}>
      {title && <h3><FormattedMessage id={title} /></h3>}
      <Table
        dataSource={dataSource}
        className={[styles.companyAttributesList, styles.visitsTable].join(' ')}
        rowKey={rowKey}
        pagination={false}
        scroll={{ x: true }}
      >
        {dataSource.map((visit) => {
          const columns = [];
          Object.keys(visit).forEach((key) => {
            if (key !== 'position') {
              const modifiedKey = key.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join('');
              columns.push(<Column
                className={styles.tableColumnWrap}
                title={intl.formatMessage({ id: `Grid.Column.${modifiedKey}` })}
                dataIndex={key}
                key={key}
                render={data => <div>{data}</div>}
              />);
            }
          });
          return columns;
        })[0]}
        {columnBtn && <Column
          key="visitId"
          title={intl.formatMessage({ id: 'Grid.Column.Details' })}
          className="text-center"
          render={(data) => {
            const { routeName, params } = columnBtnAction;
            if (includeParam) {
              params[includeParam] = data.position;
            }
            return (<div>
              <Link to={helpers.compileUrl(routeName, params)}><Icon type="idcard" /></Link>
            </div>);
          }}
        />}
      </Table>
      {bottomBtn && <Button type="primary" onClick={bottomBtnAction}>
        {bottomBtn}
      </Button>}
    </div>);
  }
}

export default connect(({ app, loading }) => ({ app, loading }))(injectIntl(VisitsTable));



// WEBPACK FOOTER //
// ./src/components/VisitsTable/VisitsTable.js